// The few brand colours that have to reach SVG attributes and gradients, where a
// Tailwind class cannot go. Mirrors `theme.extend.colors.brand` in tailwind.config.js
// (build-guide §4) — change both together.
export const COLOR = {
  jasper: '#CA4330',
  plum: '#853F82',
  leaf: '#2F6B3A',
  ink: '#27201B',
  parchment: '#F5EDD2',
  line: '#EDE2C6',
  white: '#FFFFFF',
}
